import { MediaPlayerEmbed } from '@bnnvara/embeds';
import React from 'react';

// create new video component with environment aware url
const withMediaPlayerUrl = (url) => (props) => (
  <MediaPlayerEmbed url={url} {...props} />
);

export default withMediaPlayerUrl;
